/* eslint-disable @wix/da/window-object-typeof-check */
import { useEffect } from 'react';
/**
 * Registers a global keydown event handler.
 *
 * If you find yourself checking the event target, it may be better to attach the
 * event handler directly on that element.
 */
export function useKeyDown(callbacks, enabled, ignoreInputs) {
    if (enabled === void 0) { enabled = true; }
    if (ignoreInputs === void 0) { ignoreInputs = false; }
    useEffect(function () {
        if (Object.keys(callbacks).length === 0 || !enabled) {
            return;
        }
        var handleKeyDown = function (e) {
            if (ignoreInputs) {
                var source = e.target;
                if (source.className.includes('Draft') ||
                    source.tagName.match(/input|textarea/i)) {
                    return;
                }
            }
            if (callbacks.hasOwnProperty(e.key)) {
                callbacks[e.key](e);
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return function () { return window.removeEventListener('keydown', handleKeyDown); };
    }, [callbacks, enabled, ignoreInputs]);
}
//# sourceMappingURL=useKeyDown.js.map